import React from 'react';
import { useAccountDetails } from '../hooks/use-account-details.js';
import AccountDetailsPageView from './account-details-page-view.jsx';

function AccountDetailsPageContainer() {
  const state = useAccountDetails();
  return <AccountDetailsPageView {...state} />;
}

export default AccountDetailsPageContainer;
